//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BooleanResultDTO } from 'src/app/core/interfaces/general/boolean-result';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class MdmIntuneService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public canConnect(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                                eSimApiPaths.MdmIntune + "/" +
                                                                                eSimApiPaths.MdmIntuneCanConnect +
                                                                                "?companyIdEncSS=" + companyIdEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public canConnectTestAllForHierarchy(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                                eSimApiPaths.MdmIntune + "/" +
                                                                                eSimApiPaths.MdmIntuneCanConnectTestAllForHierarchy +
                                                                                "?companyIdEncSS=" + companyIdEncSS);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public syncAllDevices(): Observable<BooleanResultDTO> {
    try {
      //CRN_20260528 - Test a method invoked via an Azure Logic App

      return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                          eSimApiPaths.MdmIntune + "/" +
                                                          eSimApiPaths.MdmIntuneSyncAllDevices);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public syncDevices(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.MdmIntune + "/" +
                                                               eSimApiPaths.MdmIntuneSyncDevices +
                                                               "?companyIdEncSS=" + companyIdEncSS,
                                                               {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public syncDevicesForHierarchy(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.MdmIntune + "/" +
                                                               eSimApiPaths.MdmIntuneSyncDevicesForHierarchy +
                                                               "?companyIdEncSS=" + companyIdEncSS,
                                                               {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public syncManagedDevicesToDb(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.MdmIntune + "/" +
                                                               eSimApiPaths.MdmIntuneSyncManagedDevicesToDb +
                                                               "?companyIdEncSS=" + companyIdEncSS,
                                                               {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public syncManagedDevicesToDbForHierarchy(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.MdmIntune + "/" +
                                                               eSimApiPaths.MdmIntuneSyncManagedDevicesToDbForHierarchy +
                                                               "?companyIdEncSS=" + companyIdEncSS,
                                                               {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public syncUsersToDb(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.MdmIntune + "/" +
                                                               eSimApiPaths.MdmIntuneSyncUsersToDb +
                                                               "?companyIdEncSS=" + companyIdEncSS,
                                                               {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public syncUsersToDbForHierarchy(companyID: number): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.MdmIntune + "/" +
                                                               eSimApiPaths.MdmIntuneSyncUsersToDbForHierarchy +
                                                               "?companyIdEncSS=" + companyIdEncSS,
                                                               {});
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public testAllIntuneConnections(): Observable<BooleanResultDTO> {
    try {
      //CRN_20260528 - Test a method invoked via an Azure Logic App

      return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                          eSimApiPaths.MdmIntune + "/" +
                                                          eSimApiPaths.MdmIntuneTestAllIntuneConnections);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
